/**
 * The product page's tabs, and the Turkish word each is addressed by in
 * `?sekme=`: a notice about a product elsewhere in the panel — a channel's list
 * of what is waiting to be sent — links to the tab where it is mended, rather
 * than to the page's first tab and a search for it.
 */
const SECTIONS = {
    genel: 'general',
    gorseller: 'images',
    stok: 'stock',
    kanallar: 'channels',
    varyantlar: 'variants',
} as const;

export type ProductSection = keyof typeof SECTIONS;
export type ProductTab = (typeof SECTIONS)[ProductSection];

/** Where a link into a product lands: a tab, and on the channels tab, one channel. */
export interface ProductPageSearch {
    sekme?: ProductSection;
    kanal?: string;
}

/**
 * The route's reading of its address: anything it does not know is dropped. Own
 * keys only, so a word that is a property of every object (`toString`) is as
 * unknown as any other.
 */
export function validateProductSearch(search: Record<string, unknown>): ProductPageSearch {
    const out: ProductPageSearch = {};
    if (typeof search.sekme === 'string' && Object.hasOwn(SECTIONS, search.sekme)) out.sekme = search.sekme as ProductSection;
    if (typeof search.kanal === 'string' && search.kanal !== '') out.kanal = search.kanal;
    return out;
}

/**
 * The tab a product page opens on. Its word is checked again here: the router
 * merges the route's reading with the address's own parameters, so a word the
 * route dropped still reaches the page, and named no tab at all.
 */
export function productTab(search: ProductPageSearch): ProductTab {
    const { sekme } = validateProductSearch({ sekme: search.sekme });
    return sekme ? SECTIONS[sekme] : 'general';
}
